import { GitBranch, Target, Workflow, Zap } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "processManagement",
  slug: "gestao-processos",
  icon: GitBranch,
  useCases: [
    { key: "mapping", icon: Workflow },
    { key: "optimization", icon: Target },
    { key: "automation", icon: Zap },
    { key: "governance", icon: GitBranch },
  ],
  benefits: ["cycle", "errors", "traceability", "roi"],
  formApplication: "Gestão de Processos",
};

const GestaoProcessos = () => <ApplicationPage config={config} />;

export default GestaoProcessos;
